import React from 'react';
import classnames from 'classnames';

import classes from './MixAndMatchSelector.scss';

export const MixAndMatchSelectorDummy: React.FC<{ title: string; className: string }> = ({ title, className }) => {
    return (
        <div className={classnames(classes.selectorDisplay, classes.disabledSelector, className)}>
            {title}
            <img
                className={classes.arrowDown}
                src={require('../../static/icons/MixMatchArrowDown.png')}
                alt="Arrow Down"
            />
        </div>
    );
};
